/* Desktop mega menu engine (rebuild step 1, 2026-07-09).
   Replaces the desktop half of the retired mega-menu.js. One controller
   element (<lma-mega-menu>) wraps the desktop nav and drives every dropdown
   by delegation, so the menu markup in mega-desktop-menu.liquid is unchanged
   and the existing CSS classes (.showDropdown, .dropdown_name_click,
   .svg_color) keep working.
   Pattern reference: Palo Alto 9's HoverDisclosure (theme.dev.js:2314),
   adapted per Kris's ruling from hover-open to click-open, with 9's
   header-background animation omitted (our panels paint their own
   backgrounds). No jQuery. Mobile drill-down stays in
   lma-kris-menu-mobile.js until rebuild step 3. */

(function () {
  if (customElements.get('lma-mega-menu')) return;

  var DESKTOP = window.matchMedia('(min-width: 1260px)');

  class LmaMegaMenu extends HTMLElement {
    connectedCallback() {
      this.entries = [];

      var n = 0;
      this.querySelectorAll('li').forEach(function (item) {
        var trigger = item.querySelector('.dropdown_name');
        var panel = item.querySelector('.dropdown_menu_container');
        if (!trigger || !panel) return;
        n += 1;
        if (!panel.id) panel.id = 'lma-mega-panel-' + n;
        /* the trigger is a div in the current markup; make it a real
           keyboard citizen until step 2 turns it into a <button> */
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', panel.id);
        this.entries.push({trigger: trigger, panel: panel});
      }, this);

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      this.onDocClick = function (e) {
        if (!this.contains(e.target)) this.closeAll();
      }.bind(this);
      document.addEventListener('click', this.onDocClick);

      this.addEventListener('focusout', function (e) {
        if (!this.contains(e.relatedTarget)) this.closeAll();
      }.bind(this));

      /* leaving desktop width: clear open state so nothing is stuck */
      this.onBreakpoint = function () {
        if (!DESKTOP.matches) this.closeAll();
      }.bind(this);
      DESKTOP.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      DESKTOP.removeEventListener('change', this.onBreakpoint);
    }

    entryFor(el) {
      for (var i = 0; i < this.entries.length; i++) {
        if (this.entries[i].trigger === el) return this.entries[i];
      }
      return null;
    }

    isOpen(entry) {
      return entry.trigger.getAttribute('aria-expanded') === 'true';
    }

    onClick(e) {
      if (!DESKTOP.matches) return;
      var trigger = e.target.closest('.dropdown_name');
      var entry = trigger && this.entryFor(trigger);
      if (!entry) return;
      /* a trigger wrapped in a real link: first click opens the dropdown,
         a second click follows the link (none are wrapped on live today) */
      if (!(this.isOpen(entry) && trigger.closest('a[href]'))) e.preventDefault();
      this.isOpen(entry) ? this.close(entry) : this.open(entry);
    }

    onKeydown(e) {
      if (!DESKTOP.matches) return;
      if (e.code === 'Escape') {
        var open = null;
        for (var i = 0; i < this.entries.length; i++) {
          if (this.isOpen(this.entries[i])) open = this.entries[i];
        }
        this.closeAll();
        if (open) open.trigger.focus();
        return;
      }
      if (e.code !== 'Enter' && e.code !== 'Space') return;
      var entry = this.entryFor(e.target);
      if (!entry) return;
      e.preventDefault();
      this.isOpen(entry) ? this.close(entry) : this.open(entry);
    }

    open(entry) {
      this.entries.forEach(function (other) {
        if (other !== entry) this.close(other);
      }, this);

      /* the old engine also dismissed an open search bar; keep that */
      document.querySelectorAll('[data-nav-search].nav-search--is-visible').forEach(function (el) {
        el.classList.remove('nav-search--is-visible');
      });

      entry.panel.classList.add('showDropdown');
      entry.trigger.classList.add('dropdown_name_click');
      entry.trigger.setAttribute('aria-expanded', 'true');
      entry.trigger.querySelectorAll('svg').forEach(function (svg) {
        svg.classList.add('svg_color');
      });
    }

    close(entry) {
      entry.panel.classList.remove('showDropdown');
      entry.trigger.classList.remove('dropdown_name_click');
      entry.trigger.setAttribute('aria-expanded', 'false');
      entry.trigger.querySelectorAll('svg').forEach(function (svg) {
        svg.classList.remove('svg_color');
      });
    }

    closeAll() {
      this.entries.forEach(this.close, this);
    }
  }

  customElements.define('lma-mega-menu', LmaMegaMenu);
})();
